import request from '../../untils/request'

//竞媒对比 播报
export const Hongshannet = params => {
  return request({
    method: 'GET',
    url: '/lsg-bigscreen/Wemedia/Hongshannet',
    params
  })
}